<template>

  <div>    

    <div class="d-none" id="printingHeaderDefault">

      <v-row>
        <!-- <v-col cols="2" align="center"  justify="center">
          <v-img
            :eager="true"
            :src="require('@assets/logo/Logo_SemFundo_Agrosim_bem_reduzido.png')" alt="AgroSim"
            max-width="100"
            class="ma-2 "
            contain
          />
        </v-col> -->
        <v-col cols="12">
          <div class="mt-7 mb-5">
            <span class="display-1 ma-3">{{ loggedUser.ground ? loggedUser.ground.name : '' }} - {{ printTitle }}</span>
          </div>
        </v-col>
      </v-row>
    </div>



    <v-btn class="mx-2 d-none d-md-inline-flex" @click="print" :disabled="disabledPrint" v-if="!printing">
      {{ printButtonLabel }}
      <v-icon right dark>mdi-printer</v-icon>
    </v-btn>

    <div class="d-none" id="printingFooterDefault">
      <v-row>
        <v-col cols="2" align="center" justify="center">
          <v-img :eager="true" :src="require('@assets/logo/Logo_SemFundo_Agrosim_bem_reduzido.png')" alt="AgroSim"
            max-width="80" class="ma-2 " contain />
        </v-col>
        <v-col cols="10">
          <div class="mt-7">
            <span class="subtitle-1">Impresso por: {{ loggedUser ? (loggedUser.person ? loggedUser.person.name : '') :
              '' }} -
              {{ getNowDateTime() | formatDateTime }}</span>
          </div>
        </v-col>
      </v-row>
    </div>   


  </div>


</template>




<script>
import jsPDF from 'jspdf'
import html2canvas from "html2canvas"
import moment from "moment";

export default {
  data: function () {
    return {
      printing: false,
      dialog: false,
      loggedUser: {},
    }
  },
  props: {
    printButtonLabel: {
      type: String,
      default: "Imprimir"
    },
    printableElementId: {
      type: String,
      require: true
    },
    printTitle: {
      type: String,
      default: "Relatório AgroSim"
    },
    disabledPrint: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.getCurrentUser(user => {
      this.loggedUser = user;
    });
  },
  methods: {
    print: async function () {
      // var pdf = new jsPDF("p", "mm", "a4");      
      this.printing = true;
      this.$emit("start-printing");

      var element = document.getElementById(this.printableElementId);

      var header = document.getElementById("printingHeaderDefault").cloneNode(true);
      header.id = "printingHeader";
      header.classList.remove("d-none");

      element.insertBefore(header, element.firstChild);

      var footer = document.getElementById("printingFooterDefault").cloneNode(true);
      footer.id = "printingFooter";
      footer.classList.remove("d-none");

      element.insertBefore(footer, element.lastChild.nextSibling);

      try {
        var canvas = await html2canvas(element);
        console.log(canvas);
        var imgData = canvas.toDataURL('image/jpeg', 1.0);
        console.log("img", imgData);
        var imgWidth = 290;
        var pageHeight = 205;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;
        console.log("algo");
        var doc = new jsPDF('l', 'mm');
        // doc.addFont('ArialMS', 'Arial', 'normal');
        // doc.setFont('Arial');
        var position = 0; // give some top padding to first page
        var idx = 0;
        // console.log("imgWidth, pageHeight, imgHeight, heightLeft, position");
        while (heightLeft > 0) {
          if (idx > 0) {
            doc.addPage();
          }
          // console.log(imgWidth, pageHeight, imgHeight, heightLeft, position);
          doc.addImage(imgData, 'JPEG', 5, position, imgWidth, imgHeight);
          position -= pageHeight;
          heightLeft -= pageHeight;
          idx++;
        }

        header.remove();
        footer.remove();
        this.$emit("stop-printing");        
        this.printing = false;
        doc.save(this.printTitle + '.pdf');
        // doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        // heightLeft -= pageHeight;

        // while (heightLeft > 0) {
        //   position += heightLeft - imgHeight; // top padding for other pages
        //   doc.addPage();
        //   doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        //   heightLeft -= pageHeight;
        // }
      } catch (er) {
        // console.log(er);
        header.remove();
        footer.remove();
        this.$emit("stop-printing");
        this.$emit("printError");
        this.printing = false;        
      }
    },
    getNowDateTime: function () {
      return moment().format('YYYY-MM-DD HH:mm');
    }
  }
}
</script>

<style scoped>
.background{
  color: #c5c5c5;
}

</style>
